import { render, staticRenderFns } from "./GeneralQuestionsPanels.vue?vue&type=template&id=10d4297e&"
import script from "./GeneralQuestionsPanels.vue?vue&type=script&lang=js&"
export * from "./GeneralQuestionsPanels.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/questionnaires/components/general-question-panels.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports